import React, { useCallback, useMemo, useRef, useState } from 'react';
import { LanguagePairLink } from 'src/types/link';
import { useKeyboardShortcut, useOutsideAlerter } from 'src/hooks';
import { LinkImage } from '../LinkImage';
import { getLinksByColumns } from './getLinksByColumns';
import * as S from './styles';
import ArrowSvg from './icons/arrow.svg';

type DropdownSublistProps = {
  buttonText: string;
  links: LanguagePairLink[];
};

export const DropdownSublist = ({ buttonText, links }: DropdownSublistProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleBtnClick = useCallback(() => {
    setIsOpen(currentState => !currentState);
  }, [setIsOpen]);
  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);
  const linksByColumns = useMemo(() => getLinksByColumns(links), [links]);

  useKeyboardShortcut('esc', handleClose);

  const popoutRef = useRef<HTMLDivElement>(null);
  useOutsideAlerter(popoutRef, handleClose);

  return (
    <S.DropdownSublist ref={popoutRef}>
      <S.SublistButtonWrapper>
        <S.SublistButton onClick={handleBtnClick}>{buttonText}</S.SublistButton>
      </S.SublistButtonWrapper>

      {isOpen && <S.DropdownArrow Svg={ArrowSvg} />}

      <S.DropdownOptions show positionX="center" noBackdrop limitHeight $show={isOpen}>
        <S.DropdownContent>
          {linksByColumns.map((columnLinks, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <S.Sublist key={index}>
              {columnLinks.map(link => (
                <S.SublistItem key={link.text}>
                  <S.SublistItemContent>
                    <S.SublistItemFlag>
                      <LinkImage {...link.image} />
                    </S.SublistItemFlag>
                    <S.SublistLink href={link.href}>{link.text}</S.SublistLink>
                  </S.SublistItemContent>
                </S.SublistItem>
              ))}
            </S.Sublist>
          ))}
        </S.DropdownContent>
      </S.DropdownOptions>
    </S.DropdownSublist>
  );
};
